/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_Story_SearchInputs */

const vi_shop_group_story_search = /** @type {(inputs: Shop_Group_Story_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm theo tiêu đề câu chuyện…`)
};

/**

* @param {Shop_Group_Story_SearchInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_story_search = /** @type {((inputs?: Shop_Group_Story_SearchInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Story_SearchInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_story_search(inputs)
});